export const HOME_PAGE_URL = "https://poznaj-testy.pl/"
export const MEDIA_PATH = "https://dacmwwxjyw.cfolks.pl/files/pytania/"

export const KOMP_WIEDZY_OFERTA = "https://poznajtesty.pl/szkolenia/kompendium-wiedzy"